<template>
<div>
  <div>
    <inputdialog ref="inputdialog"></inputdialog>

    <customdialog v-model="dialogAyarKaydet" :title="$t('Integrator-Settings')">
      <v-card color="yellow accent-2">
        <br>
        <v-select v-model="entegrator" hide-details :label="$t('Integrator')" :items="MakeEntegratorList()" v-on:change="entegratorChange()" outline> </v-select>
        <br>
      </v-card>
      <br>

      <v-text-field v-for="(value, key) in ayar" :label="key" :key="key.id" v-model="ayar[key]" hide-details> </v-text-field>
      <br>
      <v-btn color="primary" small @click="yeniParametre()">{{ $t('Add') }}</v-btn>

      <template slot="btn">
        <v-btn color="primary" flat @click="AyarKaydet()">{{$t("save_button")}}</v-btn>
      </template>
    </customdialog>

    <customdialog v-model="dialogPrmKaydet" :title="$t('E-Invoice-Parameters')">
      <v-checkbox v-model="prm.Unvan2Pasif" :label="$t('Do-not-send-Current2')"></v-checkbox>
      <v-checkbox v-model="prm.BorusanFaturasi" :label="$t('Borusan-Invoice')"></v-checkbox>
      <v-checkbox v-model="prm.FaturaTarihiDegismesin" :label="$t('invoices-7-days')"></v-checkbox>
      <v-checkbox v-model="prm.SabitSeri" :label="$t('Invoice-Serial-Constant')"></v-checkbox>
      <v-checkbox v-model="prm.FaturaGonderilmisUyarisiGonderimiKesmesin" :label="$t('Warning-Invoice-Delivered')"></v-checkbox>
      <v-checkbox v-model="prm.AciklamaToSellersItemIdentification" :label="$t('SellersItemIdentification-Area')"></v-checkbox>
      <v-text-field v-model="prm.EFatSeriSonHarf" :label="$t('Third-character-Invoice-No')" maxlength="1"></v-text-field>

      <v-checkbox v-model="prm.Adres2Birlestir" :label="$t('Merge-Address-2')"></v-checkbox>
      <v-text-field v-model="prm.BankaIBAN" :label="$t('BANK-IBAN')" maxlength="50"></v-text-field>
      <v-text-field v-model="prm.BankaParaBirimi" :label="$t('Bank-Currency-Type')" maxlength="3"></v-text-field>
      <v-text-field v-model="prm.BankaNot" :label="$t('Bank-Note')" maxlength="150"></v-text-field>

      <v-text-field v-model="prm.BankaOdemeTipi" :label="$t('Bank-Payment-Method')" maxlength="15"></v-text-field>
      <v-text-field v-model="prm.BankaOdemeKanalKodu" :label="$t('Bank-Payment-Channel-Code')" maxlength="15"></v-text-field>
      
      <v-checkbox v-model="prm.VadeTarihiYaz" :label="$t('Write-Term-Date')"></v-checkbox>
      
      <v-text-field v-model="prm.TevkifatAciklama" :label="$t('Withholding-Explanation')" maxlength="150"></v-text-field>

      <v-checkbox v-model="prm.TCKN_UnvanYaz" :label="$t('Write-Title-details-invoices-issued-TCID')"></v-checkbox>
      <v-checkbox v-model="prm.TCKN_UnvanAdSoyad" :label="$t('Write-name-surname-Title-details-invoices-issued-TCID')"></v-checkbox>
    




      <template slot="btn">
        <v-btn color="primary" flat @click="PrmKaydet()">{{$t("save_button")}}</v-btn>
      </template>
    </customdialog>
  </div>

  <basepage :title="GetTitle()" :status="status" :menuitems="menuItems" v-on:menuclick="menuClick">
    <template slot="toolbar">
      <v-text-field v-model="aranacak" flat="" solo-inverted="" hide-details :label="this.$t('Search')" append-icon="search"></v-text-field>
      <v-btn :disabled="status.loading" flat @click="kayitgetir()">Ara</v-btn>
    </template>

    <div class="input-group">

      <div>
        <v-radio-group v-model="radioGroup" row>
          <v-radio label="E Fatura" :value="1"></v-radio>
          <v-radio label="E Arşiv" :value="2"></v-radio>

          <v-btn :disabled="status.loading" color="primary" dark @click="SelectedSend()">  {{ $t('Show-Selected') }} 
            <v-icon dark right>backup</v-icon>
          </v-btn>

        </v-radio-group>

      </div>
    </div>

    <v-toolbar dark color="info">
      <v-toolbar-title>{{ $t('Bills') }}</v-toolbar-title>
    </v-toolbar>
    <v-data-table v-model="selected" :headers="headers" :items="desserts" :pagination.sync="pagination" select-all item-key="Ref" class="elevation-1">
      <template v-slot:headers="props">
        <tr>
          <th>
            <v-checkbox :input-value="props.all" :indeterminate="props.indeterminate" primary hide-details @click.stop="toggleAll"></v-checkbox>
          </th>
          <th v-for="header in props.headers" :key="header.text" :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']" @click="changeSort(header.value)">
            <v-icon small>arrow_upward</v-icon>
            {{ header.text }}
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr :active="props.selected" @click="props.selected = !props.selected">
          <td>
            <v-checkbox :input-value="props.selected" primary hide-details></v-checkbox>
          </td>
          <td>{{ props.item.Ref }}</td>
          <td>{{ props.item.GuId }}</td>
          <td>{{ props.item.invoiceOnayCode }}</td>
          <td>{{ props.item.HesapKodu }}</td>
          <td>{{ props.item.OFatura.seriYilNo }}</td>
          <td>{{ props.item.SendFatura.seriYilNo }}</td>
          <td>{{ props.item.OnayFatura }}</td>
          <td>{{ props.item.faturaProgrami }}</td>
          <td class="justify-center layout px-0">
            <v-btn icon class="mx-0" @click="onizleme(props.item.Ref,props.item.GuId)">
              <v-icon color="teal">search</v-icon>
            </v-btn>
          </td>

        </tr>
      </template>
    </v-data-table>

    <v-toolbar dark color="info">
      <v-toolbar-title> {{ $t('Result-of-Sending') }} </v-toolbar-title>
    </v-toolbar>

    <v-data-table :headers="headers2" :items="desserts2" class="elevation-1">
      <template v-slot:items="props">

        <td>{{ props.item.id }}</td>
        <td>{{ props.item.guid }}</td>
        <td>{{ props.item.oFaturaNo }}</td>
        <td>{{ props.item.senFaturaNo }}</td>
        <td>{{ props.item.message }}</td>
        <td>{{ props.item.error }}</td>
        <td class="justify-center layout px-0">
          <v-btn icon class="mx-0" @click="onizleme(props.item.id,props.item.guid)">
            <v-icon color="teal">search</v-icon>
          </v-btn>
        </td>

      </template>
    </v-data-table>

    Test Bolgesi

    <v-form ref="formaktarim" id="formaktarim" method="post" enctype="multipart/form-data" v-model="valid" lazy-validation>
      <input hidden type="file" id="files" ref="files" multiple v-on:change="handleFilesUpload()" />
    </v-form>
    <v-btn :loading="false" :disabled="false" color="info" dark @click="addFiles()">
      <v-icon color="white" left>attach_file</v-icon> {{ $t('Select-Transfer-File') }}
    </v-btn>

    <v-btn :loading="false" :disabled="false" color="info" dark @click="EkliDosyalarEkle()">
      {{ $t('Send') }}
    </v-btn>

    <v-btn :loading="false" :disabled="false" color="info" dark @click="DownloadFile()">
      indir
    </v-btn>

    <v-btn :loading="false" :disabled="false" color="info" dark @click="EkliDosyaDegistir()">
      {{ $t('Change-Attached-File') }}
    </v-btn>

    <v-btn :loading="false" :disabled="false" color="info" dark @click="EkliDosyaSil()">
       {{ $t('Delete-Attached-File') }} 
    </v-btn>


  </basepage>
</div>
</template>

<script>
import basepage from "@/components/app/coper/comp/basepage.vue";
import tool from "../coper/tools";
import customdialog from "@/components/app/coper/comp/customdialog.vue";
import inputdialog from "@/components/app/coper/comp/inputdialog.vue";
import faturaviewer from "@/components/app/coper/comp/faturaviewer.vue";

import raporsablon from "@/components/app/coper/comp/raporsablon.vue";

export default {
  components: {
    basepage,
    customdialog,
    inputdialog,
    faturaviewer,
    raporsablon

  },
  data() {
    return {
      id: 0,
      status: tool.NewSatatus(),
      entegratorList: [],
      entegrator: "",
      dialogAyarKaydet: false,
      dialogPrmKaydet: false,
      EntegratorTitle: "",

      //test files
      files: [],

      ayar: "",
      prm: {
        Unvan2Pasif: false,
        BorusanFaturasi: false,
        FaturaTarihiDegismesin: false,
        SabitSeri: false,
        EFatSeriSonHarf: "",
        FaturaGonderilmisUyarisiGonderimiKesmesin: false,
        AciklamaToSellersItemIdentification: false
      },
      aranacak: "",
      gonderilmisler: false,
      menuItems: [{
          title: this.$t('Sending-Settings')
        },
        {
          title: 'Entegratör Ayarları...'
        },
      ],
      radioGroup: 1,
      pagination: {
        sortBy: 'Ref'
      },
      selected: [],
      headers: [{
          text: 'id',
          value: 'Ref',
        },
        {
          text: 'ETN',
          value: 'GuId',
        },
        {
          text: this.$t('Approval'),
          value: 'invoiceOnayCode',
        },

        {
          text: 'HesapKodu',
          value: 'HesapKodu',
        },
        {
          text: 'OFaturaNo',
          value: 'OFatura',
        },
        {
          text: 'SendFaturaNo',
          value: 'SendFatura',
        },
        {
          text: 'OnayFatura',
          value: 'OnayFatura',
        },
        {
          text: this.$t('Program'),
          value: 'faturaProgrami',
        },
        {
          text: 'işlem',
          value: null,
        },
      ],
      desserts: [],
      desserts2: [],
      headers2: [{
          text: 'id',
          value: 'id',
        },
        {
          text: 'guid',
          value: 'guid',
        },
        {
          text: 'oFaturaNo',
          value: 'oFaturaNo',
        },
        {
          text: 'sendFaturaNo',
          value: 'sendFaturaNo',
        },
        {
          text: 'message',
          value: 'message',
        },
        {
          text: 'error',
          value: 'error',
        },
        {
          text: 'işlem',
          value: null,
        },

      ],
    };
  },
  methods: {
    AyarGoster: AyarGoster,
    AyarKaydet: AyarKaydet,

    PrmGoster: PrmGoster,
    PrmKaydet: PrmKaydet,

    GetEntegratorList: GetEntegratorList,
    MakeEntegratorList: MakeEntegratorList,
    yeniParametre: yeniParametre,
    entegratorChange: entegratorChange,
    onizleme: onizleme,
    SelectedSend: SelectedSend,
    Tip: Tip,
    GetTitle: GetTitle,
    GetEntegratorTitle: GetEntegratorTitle,

    //Test addFiles
    addFiles() {
      this.$refs.files.click();
    },

    //Test addFiles
    handleFilesUpload() {

      this.files = []

      let uploadedFiles = this.$refs.files.files;

      if (uploadedFiles.length > 0) {
        for (var i = 0; i < uploadedFiles.length; i++) {
          this.files.push(uploadedFiles[i]);
        }

      }

    },

    EkliDosyaEkle() {

      let prm = {
        SaticiTipi: 1,
        SaticiKodu: "OTELKAYITTEST",
        Aciklama: "Aciklama Yeni",
        UzunAciklama: "Uzun Açıklama yeni"
      }

      this.status.loading = true;
      tool.api_file_post2(this, "Coper/SaticiEkliDosyalarEkle", this.files, prm).then(
        response => {
          //this.items = response.body;
          this.status.loading = false;
        },
        response => {
          this.status = tool.responseToStatus(response);
        }
      );

    },

    EkliDosyaDegistir() {
      let prm = {
        Id: 9,
        Aciklama: "Aciklama Degistir",
        UzunAciklama: "Uzun Açıklama Degiştir"
      }

      this.status.loading = true;
      tool.api_file_post2(this, "Coper/SaticiEkliDosyalarDegistir", this.files, prm).then(
        response => {
          //this.items = response.body;
          this.status.loading = false;
        },
        response => {
          this.status = tool.responseToStatus(response);
        }
      );

    },

    EkliDosyaSil() {
      var prm = {
        Id: 16,
      };

      this.status.loading = true;
      tool.api_post(this, "Coper/SaticiEkliDosyalarSil", prm).then(
        response => {
          //this.items = response.body;
          this.status.loading = false;
        },
        response => {
          this.status = tool.responseToStatus(response);
        }
      );

    },

    DownloadFile() {
      var prm = {
        GuiID: '3C143E22-BD04-4760-8C41-D9E0A63F266D',
      }
      this.status.loading = true;
      tool.api_post_FileDownload(this, "Coper/DownloadFile", prm).then(
        response => {
          tool.CreateDownloadLink(response, 'EkliDosya');
          this.status.loading = false;
        },
        response => {
          this.status = tool.responseToStatus(response);
        }
      );

    },

    toggleAll() {
      if (this.selected.length) this.selected = []
      else this.selected = this.desserts.slice()
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    kayitgetir() {
      var prm = {
        eArsiv: (this.radioGroup == 2),
        gonderilmisler: this.gonderilmisler,
        aranacak: this.aranacak,
        sonid: 0
      };

      this.status.loading = true;
      this.desserts = [];
      tool.api_post(this, "EFatura/GonderilecekFaturaListesiGetir", prm).then(
        response => {
          this.desserts = response.body;
          this.status.loading = false;
        },
        response => {
          this.status = tool.responseToStatus(response);
        }
      );
    },
    menuClick(index) {
      if (index == 0) {
        this.PrmGoster();
      } else if (index == 1) {
        this.AyarGoster();
      }

    }

  },
  watch: {
    radioGroup(val) {
      this.kayitgetir()
    }
  },
  beforeMount: beforeMount,
};

function beforeMount() {

  this.GetEntegratorTitle()

}

function MakeEntegratorList() {
  var s = [];

  for (var k in this.entegratorList) {
    if (this.entegratorList.hasOwnProperty(k)) {
      s.push(k);
    }
  }
  return s;

}

function entegratorChange() {

  this.ayar = this.entegratorList[this.entegrator];
}

function AyarKaydet() {
  var prm = {
    tip: this.Tip(),
    ayar: this.ayar
  };

  this.status.loading = true;
  tool.api_post(this, "EFatura/EntegratorAyarlariKaydet", prm).then(
    response => {
      this.dialogAyarKaydet = false;
      this.status.loading = false;
    },
    response => {
      this.status = tool.responseToStatus(response);
    }
  );

}

function PrmKaydet() {
  var prm = {
    tip: this.Tip(),
    prm: this.prm
  };

  this.status.loading = true;
  tool.api_post(this, "EFatura/ParametreSave", prm).then(
    response => {
      this.dialogPrmKaydet = false;
      this.status.loading = false;
    },
    response => {
      this.status = tool.responseToStatus(response);
    }
  );

}

function GetEntegratorTitle() {
  var prm = {
    tip: this.Tip(),
  };

  //this.status.loading = true;
  tool.api_post(this, "EFatura/EntegratorTitle", prm).then(
    response => {
      this.EntegratorTitle = response.body;
    },
    response => {
      this.status = tool.responseToStatus(response);
    }
  );
}

function GetTitle() {
  if (this.radioGroup == 1) {
    return "E-Fatura " + this.EntegratorTitle;
  } else {
    return "E-Arşiv " + this.EntegratorTitle;
  }
}

function yeniParametre() {

  this.$refs.inputdialog
    .open("Yeni Parametre", "Parametre Adi", "", {
      color: "blue"
    })
    .then(confirm => {
      if (confirm !== "") {
        this.ayar[confirm] = "";
      }
    });

}

function AyarGoster() {
  var prm = {
    tip: this.Tip(),
  };

  this.status.loading = true;

  this.entegrator = null;
  this.GetEntegratorList();

  tool.api_post(this, "EFatura/EntegratorAyarlari", prm).then(

    response => {
      this.ayar = response.body;
      this.status.loading = false;
      this.dialogAyarKaydet = true;

    },
    response => {
      this.status = tool.responseToStatus(response);
    }
  );
}

function PrmGoster() {
  var prm = {
    tip: this.Tip(),
  };

  this.status.loading = true;

  tool.api_post(this, "EFatura/ParametreLoad", prm).then(

    response => {
      this.prm = response.body;
      this.status.loading = false;

      this.dialogPrmKaydet = true;

    },
    response => {
      this.status = tool.responseToStatus(response);
    }
  );
}

function GetEntegratorList() {
  var prm = {
    tip: this.Tip(),
  };

  tool.api_post(this, "EFatura/EntegratorDefValue", prm).then(
    response => {
      this.entegratorList = response.body;
    },
    response => {
      this.status = tool.responseToStatus(response);
    }
  );

}

function onizleme(id, guid) {
  var prm = {
    id: id,
    guid: guid
  };

  this.$refs.faturaviewer
    .open(prm, this.Tip())
    .then(confirm => {
      if (confirm !== "") {
        //
      }
    });

}

function SelectedSend() {
  var prm = {
    faturaTip: this.Tip(),
    faturaList: []
  };

  var i;
  for (i = 0; i < this.selected.length; i++) {
    prm.faturaList.push({
      id: this.selected[i].Ref,
      guid: this.selected[i].GuId
    });
  }
  this.status.loading = true;
  tool.api_post(this, "EFatura/EFaturaGonder", prm).then(
    response => {


      //document.getElementById("demo").innerHTML = response.body;
      this.desserts2 = response.body;
      this.status.loading = false;
    },
    response => {
      this.status = tool.responseToStatus(response);
    }
  );
}

function Tip() {
  return this.radioGroup;
}
</script>
